"use client";

import type { Session } from "next-auth";
import { SessionProvider as NextAuthSessionProvider } from "next-auth/react";

interface SessionProviderProps {
  children: React.ReactNode;
  /**
   * Server-seitig aufgelöste Session (aus `auth()` im [locale]-Layout). Wird
   * als Initialwert an NextAuth übergeben, damit `useSession()` schon beim
   * ersten Render die korrekten Nutzerdaten hat — kein „Benutzer"-Flash im
   * Header und kein Flicker des Admin-Clusters in der Sidebar.
   */
  session?: Session | null;
}

export function SessionProvider({ children, session }: SessionProviderProps) {
  return (
    <NextAuthSessionProvider
      session={session}
      refetchInterval={5 * 60}
      // Beim Zurückkehren in den Tab erneut laden — hält Rolle/Namen aktuell,
      // z.B. nach Rechteänderung durch den ADMIN in einem anderen Tab.
      refetchOnWindowFocus={true}
    >
      {children}
    </NextAuthSessionProvider>
  );
}
